import React from 'react';
import { productsContent } from '@/content/products';
import ProductsGroup from './ProductsGroup';
import { Section } from '@/components/ui';

const Products: React.FC = () => {
    return (
        <Section id="products" className="products" title={productsContent.sectionTitle}>
            <div className="product-container">
                {productsContent.groups.map((group, index) => (
                    <ProductsGroup key={group.title} {...group} delay={index * 100} />
                ))}
            </div>
        </Section>
    );
};

export default Products;
